// Kept dependency-free so helpers/util can clear it on sign-out without import cycles.
const STORAGE_KEY = "assistantConversation";

type Stored = { uuid: string; messages: unknown[] };

/** Returns the saved messages only if they belong to this user; anything else is discarded. */
export function loadConversation(uuid: string | undefined): unknown[] {
  if (!uuid) return [];
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as Partial<Stored> | null;
    if (parsed?.uuid === uuid && Array.isArray(parsed.messages)) return parsed.messages;
    clearConversation();
  } catch (_e) {
    // unreadable or unavailable storage: start fresh
  }
  return [];
}

export function saveConversation(uuid: string | undefined, messages: unknown[]) {
  try {
    if (!uuid || !messages.length) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ uuid, messages } satisfies Stored));
  } catch (_e) {
    // storage unavailable or full; the conversation just won't survive a reload
  }
}

export function clearConversation() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_e) {
    // noop
  }
}
